
export const SOME_ERROR_OCCURRED_KEY = 'someErrorOccured';

export const sharedAppI18nPtPT: Record<any, any> = {
  '*': {
    AT_ACTIONS_MENU: {
      save: 'Guardar',
      load: 'Abrir',
      validate: 'Validar',
      print: 'Imprimir',
      schema: 'Esquema',
      value: 'Valor',
      error: 'Erro',
      submit: 'Submeter',
      language: 'Idioma',
      'clear-errors': 'Limpar erros',

      'pt-PT': 'PT',
      'en-US': 'EN',

    },
    [SOME_ERROR_OCCURRED_KEY]: 'Erro inesperado!',
    'select-language': 'Selecionar Idioma',
    validations: {
      UNALLOWED_VALUE_CODE: 'Valor não permitido.',
      FREE_TEXT_INVALID_CHARACTER: 'Texto possui caráter especial inválido.'
    }
  }
};
